"use client";

import { useEffect } from "react";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";
import { markToasterReady } from "@/lib/toasterReady";

export default function SonnerToasterReady(props: ToasterProps) {
  useEffect(() => {
    markToasterReady();
  }, []);

  return <SonnerToaster {...props} />;
}
